import {$body, $window, $document} from '../utils/environment';
import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.minWidth = 999;

        this.dom = {};

        this.init();
    }

    /**
     * Initialiation.
     *
     * @return {void}
     */
    init() {
        // clique sur un lien de type sous menu
        this.$el.on('click.HeaderCategories', '.js-header-categories', (e) => {
            if (window.matchMedia(`(min-width: ${this.minWidth}px)`).matches) {
                this.onClickHeaderCategories(e);
            }
        });

        // clique sur un lien de type box items
        this.$el.on('click.HeaderCategories', '.js-header-selectors', (e) => {
            if (window.matchMedia(`(min-width: ${this.minWidth}px)`).matches) {
                this.onClickHeaderSelectors(e);
            }
        });

        // clique sur un lien de type search
        this.$el.on('click.HeaderCategories', '.js-header-search', (e) => {
            this.onClickHeaderSearch(e);
        });

        // clique sur un item dans le header
        this.$el.on('click.HeaderCategories', '.js-header-categories-item', (e) => {
            if (window.matchMedia(`(min-width: ${this.minWidth}px)`).matches) {
                this.onClickCategoriesItem(e);
            }
        });

        // clique sur le background noir
        $('.js-header-overlay').on('click.HeaderCategories', () => this.close());

        //Push sur la touche esc
        $window.on('keyup.HeaderCategories',(e) => {
            if (e.keyCode === 27) {
                this.close();
            }
        });

        //listen event to reset headerCategories
        $document.on('rebuild.HeaderCategories',(e) => {
             this.close();
        });

        //listen event to reset headerCategories
        $document.on('reinitFired.HeaderCategories',(e) => {
             this.reinitFired();
        });
    }

    /**
     * Événement lorsque l'on souhaite afficher le
     * menu `HeaderCategories`.
     *
     * @param {event}  événement lors du clique
     * @return {void}
     */
    onClickHeaderCategories(event) {
        event.preventDefault();

        $('.js-header-selectors.is-active').removeClass('is-active');
        $('.c-navigation-categories').removeClass('is-hselectors-open');

        if ($body.hasClass('has-header-categories')) {
            $body.removeClass('has-header-categories')
        } else {
            $body.addClass('has-header-categories').removeClass('has-header-search has-header-selectors');
            $body.removeClass('search-has-results');
        }
    }

    /**
     * Événement lorsque l'on souhaite afficher le
     * menu `HeaderSearch`.
     *
     * @param {event}  événement lors du clique
     * @return {void}
     */
    onClickHeaderSearch(event) {
        event.preventDefault();

        $('.js-header-selectors.is-active').removeClass('is-active');
        $('.c-navigation-categories').removeClass('is-hselectors-open');

        if ($body.hasClass('has-header-search')) {
            $body.removeClass('has-header-search');
            $body.removeClass('search-has-results');
        } else {
            $body.addClass('has-header-search').removeClass('has-header-categories has-header-selectors');
        }
    }

    /**
     * Événement lorsque l'on souhaite afficher la
     * sélection du type de sport.
     *
     * @param {event}  événement lors du clique
     * @return {void}
     */
    onClickHeaderSelectors(event) {
        event.preventDefault();
        let $elem = $(event.currentTarget);

        if ($elem.data('ident')) {
            let $selector = $('.c-navigation-categories[data-ident="'+$elem.data('ident')+'"]');
            if ($selector.hasClass('is-hselectors-open')) {
                $('.c-navigation-categories').removeClass('is-hselectors-open');
                $selector.removeClass('is-hselectors-open');
            } else {
                $('.c-navigation-categories:not([data-ident="'+$elem.data('ident')+'"])').removeClass('is-hselectors-open');
                $selector.addClass('is-hselectors-open');
            }
        }

        if(!$elem.hasClass('is-active')){
            $('.js-header-selectors.is-active').removeClass('is-active');
            $elem.addClass('is-active');
            $body.addClass('has-header-selectors').removeClass('has-header-search has-header-categories');

        }else{
            $elem.removeClass('is-active');
            $body.removeClass('has-header-selectors');

        }

    }

    /**
     * Événement lorsque l'on clique sur un item
     * présent dans le menu `HeaderCategories`.
     *
     * @param {event}  événement lors du clique
     * @return {void}
     */
    onClickCategoriesItem(event) {
        event.preventDefault();
        $body.removeClass('has-header-categories has-header-selectors');
    }

    /**
     * Événement lorsque l'on push la touche escape, ou quand on change de page pour reset les classes
     *
     * @return {void}
     */
     close(){

        //reset active item
        $('.js-header-selectors.is-active').removeClass('is-active');

        // reset opening class on categories
        $('.c-navigation-categories').removeClass('is-hselectors-open');

        $body.removeClass('has-header-categories has-header-selectors has-header-search');
        $body.removeClass('search-has-results');

     }

     /**
      * Événement lorsque l'on arrive sur une page, venant d'une transition de header categories
      *
      * @return {void}
      */
     reinitFired(){
        $('.js-navigation-item').removeClass('is-fire');
     }

    /**
     * Déstructeur.
     *
     * @return {void}
     */
    destroy() {
        this.$el.off('.HeaderCategories');
        $window.off('.HeaderCategories');
        $('.js-header-overlay').off('.HeaderCategories');
    }
}
